import React, {useEffect} from 'react';
import ReactDOM from 'react-dom';

import App		from 	'./vortex/App'
import AppProject		from 	'./vortex/AppProject'

import FormLog from './vortex/model/Invoices/FormLog';

ReactDOM.render(<AppProject />, document.getElementById('root'));
